import { CtvtVoltageLevel } from "../enums/ctvt-voltage-level.enum";
import { MeterInventoryType } from "../enums/meter-inventory-type.enum";
import { CustomerType, TypeOfConnection } from "./customer.model";

export class NewMeterStockItemDto {
    meterNumber?: string = '';
    lifespan?: number;
    meterPhase?: TypeOfConnection;
    meterRatingId?: number;
    meterMakeId?: number = 0;
    meterModelId?: number;
    meterType?: number;
    dtMeterTypeId?: number;
    dispatchDate?: string;
    regionId?: number = 0;
    geographicalRegionId?: number = 0;
    meterInventoryType?: MeterInventoryType;
    tagSerialNumber?: string;
    instrumentSerialNumber?: string;
    voltageLevel?: CtvtVoltageLevel;
    preloadedUnits?: string;
}
